import { useContext, useRoute } from '@nuxtjs/composition-api'
import useLocale from './useLocale'
import useComp from './useComp'

const { getCompObj } = require(`../${process.env.TEMPLATE_ID}/middleware/title`)

export default function useHead() {
  const route = useRoute()

  const { locale, locales } = useLocale()

  const { compHead } = useComp()

  const { req } = useContext()

  function genHead(path = route.value.path) {
    const head = getCompObj(path, 'head').result

    // console.log(head)

    const title = head.title[locale.value]
    const keywords = head.meta.keywords[locale.value]
    const description = head.meta.description[locale.value]

    const meta = []

    if (process.env.COMP_ID === 'kb') {
      if (
        route.value.query?.btag ||
        (process.server && req.headers?.cookie?.includes('btag=')) ||
        // eslint-disable-next-line no-undef
        (!process.server && Cookies.get('btag'))
      ) {
        meta.push({
          hid: 'twitter:image:src',
          name: 'twitter:image:src',
          content: `https://ik.imagekit.io/1pzxddx3qqv/kb/img/kb-24h-pachinko-x-img.png`
        })
      }
    }

    // console.log('title', title)

    let origin
    if (process.server) {
      origin = `http${req.secure ? 's' : ''}` + '://' + req.get('host')
    } else {
      origin = window.location.origin
    }
    let link = [
      {
        rel: 'canonical',
        href: origin + path
      }
    ]
    link = [
      ...link,
      ...locales.value.reduce((pre, cur) => {
        pre.push({
          rel: 'alternate',
          hreflang: cur,
          href: origin + (path === '/' ? '/' : path + '/') + cur
        })
        return pre
      }, [])
    ]

    return {
      title,
      meta: [
        ...meta,
        {
          hid: 'keywords',
          name: 'keywords',
          content: keywords
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'og:site_name',
          name: 'og:site_name',
          property: 'og:site_name',
          content: compHead.value.title[locale.value]
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: description
        }
      ],
      link
    }
  }

  return {
    genHead
  }
}
